/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addresshiddenlabel2Inputs */

const en_addresshiddenlabel2 = /** @type {(inputs: Addresshiddenlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the address only after confirmation`)
};

const de_addresshiddenlabel2 = /** @type {(inputs: Addresshiddenlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse erst nach Bestätigung zeigen`)
};

/**
* | output |
* | --- |
* | "Show the address only after confirmation" |
*
* @param {Addresshiddenlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addresshiddenlabel2 = /** @type {((inputs?: Addresshiddenlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addresshiddenlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addresshiddenlabel2(inputs)
	return de_addresshiddenlabel2(inputs)
});
export { addresshiddenlabel2 as "addressHiddenLabel" }